import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DeleteIcon } from 'tdesign-icons-react';
import { Button, Drawer, Link, MessagePlugin, Popconfirm } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import CountUp from 'react-countup';
import PermWrapper from '@/components/PermWrapper';
import { fetchFunctionDetail } from '@/slices/functionSlice';
import { removeFunction, updateFunctionNote } from '@/services/functionService';
import ModalHeader from '@/components/Header/Modal';
import SummaryPanel from '@/components/Cluster/SummaryPanel';
import Description from '../../../components/Description';

function Detail({ row, clusterName, onRefresh, fetchFunctionDetail, loading, detail }) {
  const [visible, setVisible] = useState(false);

  const onClose = () => setVisible(false);

  const items = [
    {
      title: 'Function实例数',
      icon: 'other2',
      info: <CountUp end={detail.functionInstanceNum} duration={0.4} />,
      unit: '个',
    },
    {
      title: '运行时长',
      icon: 'other4',
      info: detail.runHours || '0h',
    },
    {
      title: '异常个数',
      icon: 'other3',
      info: <CountUp end={detail.functionExceptionNum} duration={0.4} />,
      unit: '个',
    },
  ];

  const handleDelete = async () => {
    await removeFunction({
      clusterName,
      functionName: row.functionName,
    });
    MessagePlugin.success('删除成功！');
    setVisible(false);
    onRefresh();
  };

  const loadDetail = useMemoizedFn(async () => {
    fetchFunctionDetail({
      functionName: row.functionName,
      clusterName,
    });
  });

  useEffect(() => {
    if (visible) {
      loadDetail();
    }
  }, [visible, loadDetail]);

  const onNoteChange = async (note) => {
    try {
      await updateFunctionNote({
        clusterName,
        functionName: row.functionName,
        note,
      });
      MessagePlugin.success('修改成功！');
      loadDetail();
    } catch (error) {
      return false;
    }
  };

  return (
    <>
      <Link theme='primary' style={{ wordBreak: 'break-all' }} onClick={() => setVisible(true)}>
        {row.functionName}
      </Link>
      <Drawer
        visible={visible}
        size={1000}
        destroyOnClose
        footer={null}
        header={
          <ModalHeader
            tags={[`${row.tenant}/${row.namespace}/${row.functionName}`, clusterName]}
            tail={
              row.status !== 'running' && (
                <PermWrapper resource='pulsar:function:function:delete'>
                  <Popconfirm theme='danger' content='确定删除？' onConfirm={handleDelete}>
                    <Button theme='danger' variant='outline' size='small' icon={<DeleteIcon />}>
                      删除
                    </Button>
                  </Popconfirm>
                </PermWrapper>
              )
            }
          >
            Function
          </ModalHeader>
        }
        onClose={onClose}
      >
        <SummaryPanel style={{ marginTop: -12 }} shadow={false} items={items} />
        <Description loading={loading} detail={detail} onNoteChange={onNoteChange} />
      </Drawer>
    </>
  );
}

export default connect(
  (state) => ({
    loading: state.function.detailLoading,
    detail: state.function.fxDetail,
  }),
  {
    fetchFunctionDetail,
  },
)(Detail);
